<template>
    <div>
        <div>
            <!-- 헤더 -->
            <div class="modal-header">
                <select v-model="documentType" @change="changeDocumentType(documentType)" class="document-type-select">
                    <option v-for="(config, type) in documentTypes" :key="type" :value="type">
                        {{ config.name }}
                    </option>
                </select>
                <div class="header-buttons">
                    <button @click="printDocument" class="btn btn-print">인쇄</button>
                    <button @click="downloadPDF" class="btn btn-download" :disabled="isGeneratingPDF">
                        {{ isGeneratingPDF ? 'PDF 생성 중...' : 'PDF 다운로드' }}
                    </button>
                    <button @click="registerPDF" class="btn btn-register">파일 등록</button>
                    <button @click="registerAllPDF" class="btn btn-register">전체 파일 등록</button>
                </div>
            </div>

            <!-- 페이지네이션 -->
            <div class="pagination-container">
                <div class="pagination-controls">
                    <button @click="goToPreviousPage" :disabled="currentPage === 1" class="pagination-btn prev-btn">
                        ◀ 이전
                    </button>
                    <div class="page-numbers">
                        <button v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                            :class="['page-btn', { active: page === currentPage }]">
                            {{ page }}
                        </button>
                    </div>
                    <button @click="goToNextPage" :disabled="currentPage === totalPages"
                        class="pagination-btn next-btn">
                        다음 ▶
                    </button>
                </div>
            </div>

            <!-- 문서 내용 -->
            <div class="modal-content">
                <div v-if="documentType === 'contract'">
                    <!-- 1페이지 -->
                    <div v-if="currentPage === 1" class="document-wrapper">
                        <div class="document-header">
                            <div class="mini-note">■ 요양비 산소치료기 기준 및 방법 [별지 제2호 서식]</div>
                            <h1 class="document-title">산소치료서비스 표준계약서</h1>
                        </div>

                        <div class="intro-section">
                            <p class="intro-text">
                                「요양비의보험급여기준및방법」 (보건복지부고시 2016-258호, 2016.12.30)[별표2] "산소치료서비스공급자 등록 등 기준"에 의하여 국민건강보험공단에
                                산소치료서비스 제공업소로 등록한 자(이하 "갑"이라 한다)와 산소치료서비스(이하 "서비스"라 한다)를 필요로 하는 환자(이하 "을"이라 한다)는 다음과 같이
                                의료용
                                산소발생기(이하 "산소발생기"라 한다) 임대차 계약을 체결한다.
                            </p>
                        </div>

                        <div class="articles-container">
                            <!-- 제1조 -->
                            <div class="article">
                                <div class="article-title">제1조(계약의 목적)</div>
                                <div class="article-content">
                                    본 계약은 국민건강보험공단 공고 제2016-350호(2016.12.30)에 의하여 "갑"과 "을"이 산소치료서비스 계약상의 권리와 의무에 관한 사항을
                                    규정함을
                                    목적으로 한다.
                                </div>
                            </div>

                            <!-- 제2조 -->
                            <div class="article">
                                <div class="article-title">제2조(계약의 내용)</div>
                                <div class="table-container">
                                    <table class="contract-table">
                                        <thead>
                                            <tr>
                                                <th>구분</th>
                                                <th>모델명</th>
                                                <th>관리번호</th>
                                                <th>서비스금액</th>
                                                <th>임대 계약기간</th>
                                                <th>서비스금액<br>납부일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(product, index) in formattedProducts" :key="index"
                                                class="filled-row">
                                                <td>{{ product.isHomeUse ? '☑ 가정용' : '☑ 휴대용' }}</td>
                                                <td>{{ product.modelName || '' }}</td>
                                                <td>{{ product.managementNumber || '' }}</td>
                                                <td>{{ product.serviceAmount ? product.serviceAmount.toLocaleString() :
                                                    '' }}</td>
                                                <td v-if="index === 0" v-html="product.contractPeriod || ''"
                                                    :rowspan="formattedProducts.length > 1 ? formattedProducts.length : 1">
                                                </td>
                                                <td v-if="index === 0"
                                                    :rowspan="formattedProducts.length > 1 ? formattedProducts.length : 1">
                                                    {{ product.paymentDate || '' }}</td>
                                            </tr>
                                            <tr v-if="formattedProducts.length === 0">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="table-note">※ 구분 란의 해당여부 ☑ 표시</div>
                                </div>
                            </div>

                            <!-- 제3조 -->
                            <div class="article">
                                <div class="article-title">제3조(계약기간)</div>
                                <div class="article-content">
                                    <div class="clause">① 본 계약은 "갑"과 "을"이 본 표준계약서를 작성함으로써 성립된다.</div>
                                    <div class="clause">② 계약기간은 의사의 "산소치료 처방일"의 처방기간 이내로 한다.</div>
                                    <div class="clause">③ 계약기간 만료 7일 전까지 "갑" 또는 "을"이 계약 종료 의사를 표시하지 않는 한 계약기간은 연장된 것으로
                                        본다.
                                        이때 "을"은 계약기간 만료 전 7일 이내 산소치료처방전을 "갑"에게 제출하여야 한다.</div>
                                    <div class="clause">④ "을"이 사망한 경우에는 사망한 날에 본 계약이 종료된 것으로 한다.</div>
                                </div>
                            </div>

                            <!-- 제4조 -->
                            <div class="article">
                                <div class="article-title">제4조(서비스의 범위)</div>
                                <div class="article-content">
                                    서비스의 범위는 「요양비의보험급여기준및방법」 (보건복지부고시 2016-258호, 2016.12.30) 제3조 제2항 [별표2] "산소치료서비스공급자
                                    등록 등
                                    기준"에 의한다.
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2페이지 -->
                    <div v-if="currentPage === 2" class="document-wrapper">
                        <div class="articles-container">
                            <!-- 제5조 -->
                            <div class="article">
                                <div class="article-title">제5조(서비스 급여 등)</div>
                                <div class="article-content">
                                    <div class="clause">① 서비스의 급여는 1개월 단위로 산정하되 제2조에서 정한 급여로 하며, 그 급여는 최고금액(가격상한 16만원/월,
                                        휴대용은 24만원/월)을 초과하여 계약할 수 없다.</div>
                                    <div class="clause">② "갑"은 서비스 계급명에 필요한 산소발생기의 유지·보수에 소요되는 일체의 비용을 "을"에게 요구할 수 없다.
                                        다만,
                                        "을"의 고의 또는 중대한 과실로 인한 경우는 그러하지 아니한다.</div>
                                    <div class="clause">③ "을"은 본 서비스 계약이 계약기간 종료되는 경우 종료되는 날이 속하는 해당 일의 서비스 급여 산정(일, 휴대용
                                        산소발생기를 15일 이내 대여한 경우. 즉, 15일 이하일 수 있으나 그 휴대용 산소발생기 12만원/월)을 적용에 계약할 수 있다.</div>
                                </div>
                            </div>

                            <!-- 제6조 -->
                            <div class="article">
                                <div class="article-title">제6조(장비 설치, 시설과 교육, 철회 허가)</div>
                                <div class="article-content">
                                    <div class="clause">① "갑"은 계약과 산소발생기를 "을"이 요청하는 일시와 장소에 설치하고 즉시 사용할 수 있도록 한다.</div>
                                    <div class="clause">② "갑"은 "을"에게 산소발생기의 사용방법, 고장 및 긴급 시 대처방법 등 필요한 교육을 실시한다. 또한 연락방법
                                        등이
                                        포함된 사용·관리요령을 충분히 설명하도록 하여야 한다.</div>
                                    <div class="clause">③ "을"이 계약해지, 일시정지 등의 사유발생으로 "갑"에게 의뢰할 산소발생기를 수거하고 즉시 철거할 수 있는 등의
                                        장비수거하여 반환된 시설과 관한 책임은 "갑"에게 있다.</div>
                                </div>
                            </div>

                            <!-- 제7조 -->
                            <div class="article">
                                <div class="article-title">제7조(갑의 의무)</div>
                                <div class="article-content">
                                    <div class="clause">① "갑"은「요양비의보험급여기준및방법」(보건복지부고시 2016-258호, 2016.12.30) [별표2]
                                        "산소치료서비스제공업소 등록 등 기준"에 의해 공단에 등록된 산소발생기를 임대하여야 한다.</div>
                                    <div class="clause">② "갑"은 산소발생기를 임대할 경우 공단에 등록된 업소임을 "을"이 확인할 수 있도록 하여야 한다.</div>
                                    <div class="clause">③ "갑"은 "을"이 계약한 산소발생기의 장비이상 등으로 사용할 수 없는 경우에도 "을"이 계속해서 서비스를 받을
                                        수
                                        있도록 모든 조치를 취하여야 한다.</div>
                                    <div class="clause">④ "갑"은 계약후에는 "을"이 사용중인 산소발생기를 저당, 담보 등에 대한 목적물로 제공할 수 없다.</div>
                                    <div class="clause">⑤ "갑"은 산소발생기의 부작용과 안전성에 관한 정보를 알게 된 때에는 "의료기기부작용 보고 등 안전성 정보관리에
                                        관한
                                        규정"에 따라 식품의약품안전처장에게 지체없이 보고하고 이를 국민건강보험공단에 통보하여야 한다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 3페이지 -->
                    <div v-if="currentPage === 3" class="document-wrapper">
                        <div class="articles-container">
                            <!-- 제7조 -->
                            <div class="article">
                                <div class="article-content">
                                    <div class="clause">⑥ "갑"이 계약 의무를 계속해서 수행할 수 없을 때에는 사유발생 7일이내에 국민건강보험공단과 "을"에게 통보하고
                                        "을"이
                                        서비스를 지속적으로 받을 수 있도록 필요한 조치를 하여야 한다. 다만, "갑"이 부도 또는 도산으로 "을"에게 서비스를 계속 제공할 수 없는
                                        때는 그
                                        사유가 발생한 날로부터 7일 이내에 "을"과 국민건강보험공단에 통보하여야 한다.</div>
                                    <div class="clause">⑦ "갑"은 산소발생기의 종류, 서비스 내용, 서비스 금액 등의 각종 자료를 공개하고 변경사항이 발생한 때에는
                                        "을"이
                                        서비스 계약시 합리적인 선택을 할 수 있도록 즉시 공단에 신고하여야 한다.</div>
                                    <div class="clause">⑧ "갑"은 계약기간중 "을"에게 정상적인 서비스 제공을 위하여 산소발생기의 정기 및 보수점검을 하고 그 기록을
                                        작성
                                        보존하며 장비사용자인 "을"에게 장비 이상 및 수리점검내역을 고지하여야 한다.</div>
                                </div>
                            </div>

                            <!-- 제8조 -->
                            <div class="article">
                                <div class="article-title">제8조(을의 의무)</div>
                                <div class="article-content">
                                    <div class="clause">① "을"은 계약기간동안 서비스 금액을 제2조에 정한 납부일에 "갑"에게 지급하여야 한다.</div>
                                    <div class="clause">② "을"은 산소발생기를 임차 계약할 경우 "갑"이 공단에 등록된 업소임을 확인하여야 한다.</div>
                                    <div class="clause">③ "을"은 산소발생기를 용도에 따라 사용하고, "갑"이 교부한 산소발생기의 취급설명서에 따라 바르게 사용하도록
                                        하여야
                                        한다.</div>
                                    <div class="clause">④ "을"은 산소발생기를 임차한 후, 주소가 변경 또는 다른 장소로 이전할 필요가 있을 경우에는 즉시 "갑"에게
                                        통보하고
                                        그
                                        지시에 따라야 한다.</div>
                                    <div class="clause">⑤ "을"은 계약해지, 업소변경, 기타 사유로 산소발생기를 사용할 수 없게 된 때에는 7일 이내에 "갑"에게
                                        연락하여
                                        장비회수를 요청하여야 한다.</div>
                                    <div class="clause">⑥ "을"은 산소발생기에 부착된 "갑"의 소유권 표시 등을 제거 및 훼손하여서는 아니 된다.</div>
                                </div>
                            </div>

                            <div class="article">
                                <div class="article-title">제9조(해지)</div>
                                <div class="article-content">
                                    <div class="clause">① "갑"과 "을"이 서비스에 대한 당사자 간의 계약을 해지하고자 하는 때에는 해지하고자 하는 날의 7일 이전에
                                        계약
                                        상대방에게 통보하여야 한다. 이 경우 "갑"은 "을"에게 임대한 산소발생기를 회수하여야 한다.</div>
                                    <div class="clause"> ② "갑"은 "을"이 서비스 금액의 지급을 3회 이상 지체한 때에는 최고 후 계약을 해지할 수 있다.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 4페이지 -->
                    <div v-if="currentPage === 4" class="document-wrapper">
                        <div class="articles-container">
                            <!-- 제10조 -->
                            <div class="article">
                                <div class="article-title">제10조(개인정보 보호)</div>
                                <div class="article-content">
                                    <div class="clause">"갑"은 산소치료서비스 제공과 관련하여 "을"의 개인정보의 분실 및 유출방지 등 개인정보를 적절한 보호하여야 한다.
                                    </div>
                                </div>
                            </div>

                            <!-- 제11조 -->
                            <div class="article">
                                <div class="article-title">제11조(손해 배상)</div>
                                <div class="article-content">
                                    <div class="clause">① "갑"의 과실로 "을"과 제3자에게 손해를 입혔을 경우 "갑"은 그 손해를 배상하여야 한다.</div>
                                    <div class="clause">② "갑"은 제10조(개인정보 보호)의 의무를 소홀히 하여 "을" 또는 제3자에게 손해를 입혔을 경우 "갑"은
                                        "을"에게
                                        그 손해를 배상하여야 한다.</div>
                                    <div class="clause">③ "을"의 고의 또는 중대한 과실로 인하여 산소발생기의 파손, 분실에 대하여는 "을"은 "갑"에게 그 손해를
                                        배상하여야
                                        한다.</div>
                                </div>
                            </div>

                            <!-- 제12조 -->
                            <div class="article">
                                <div class="article-title">제12조(기타 사항)</div>
                                <div class="article-content">
                                    <div class="clause">① 본 계약서에 명시되지 아니한 사항이나 의견이 상이할 때에는 상호 협의하에 해결하는 것을 원칙으로 한다.
                                    </div>
                                    <div class="clause">② 위 계약체결을 증명하고 제반 의무를 성실히 수행하기 위하여 본 계약서를 2부 작성하여 서명 날인한 후 "갑"과
                                        "을"이
                                        각각 1부씩 보관한다.</div>
                                </div>
                            </div>

                            <!-- 계약일 -->
                            <div class="contract-date-section">
                                <p v-if="!isEditingContractDate" class="contract-date clickable"
                                    @click="startEditingContractDate">
                                    {{ formattedContractData.contractDate }}
                                </p>
                                <input v-else type="date" v-model="editableContractDate"
                                    @blur="finishEditingContractDate" @keyup.enter="finishEditingContractDate"
                                    @keyup.esc="cancelEditingContractDate" class="contract-date-input"
                                    ref="contractDateInput" />
                            </div>

                            <!-- 서명 섹션 -->
                            <div class="signature-section">
                                <div class="signature-box signature-gap">
                                    <div class="signature-party">
                                        (갑) 성명: {{ formattedContractData.companyName }}
                                        <span class="signature-name">(서명 또는 인)</span>
                                        <img v-if="companyStampUrl" :src="companyStampUrl" alt="회사 도장"
                                            class="company-stamp" />
                                    </div>
                                    <div class="signature-address">주소: {{ formattedContractData.companyAddress }}</div>
                                    <div class="signature-contact">연락처: {{ formattedContractData.companyContact }}</div>
                                </div>

                                <div class="signature-box">
                                    <div class="signature-party">
                                        (을) 성명: {{ formattedContractData.customerName }}
                                        <span class="signature-name">(서명 또는 인)</span>
                                    </div>
                                    <!-- 서명 캔버스를 (서명 또는 인) 바로 위에 배치 -->
                                    <div class="signature-canvas-container">
                                        <canvas ref="signatureCanvas" class="signature-canvas" @mousedown="startDrawing"
                                            @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"
                                            @touchstart="startDrawingTouch" @touchmove="drawTouch"
                                            @touchend="stopDrawing"></canvas>
                                        <button @click="clearSignature" class="clear-signature-btn">지우기</button>
                                    </div>
                                    <div class="signature-address">주소: {{ formattedContractData.customerAddress }}</div>
                                    <div class="signature-contact">연락처: {{ formattedContractData.customerContact }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 요양비청구위임장 페이지 -->
                <div v-if="documentType === 'authorization'">
                    <!-- 1페이지 -->
                    <div v-if="currentPage === 1" class="document-wrapper">
                        <div class="document-header">
                            <div class="form-header">
                                <div class="form-number">■ 국민건강보험법 시행규칙 [별지 제19홍원선식] <개정 2022. 10. 26.>
                                </div>
                                <h1 class="document-title">요양비 지급청구 위임장</h1>
                                <div class="instruction-text">
                                    ※ 뒤쪽의 유위사항을 읽고 작성해 주시기 바라며, [ ]에는 해당되는 곳에 √ 표시해 주시기 바랍니다.
                                </div>
                            </div>
                        </div>

                        <div class="authorization-form">
                            <table class="unified-form-table">
                                <tbody>
                                    <!-- ① 위임인 섹션 -->
                                    <tr>
                                        <td class="section-title-cell" rowspan="6">① 위임인</td>
                                        <td class="label-cell" rowspan="2">가입자 또는<br>피부양자</td>
                                        <td class="label-cell">성명</td>
                                        <td class="value-cell">{{ formattedContractData.customerName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">주민(외국인) 등록번호</td>
                                        <td class="value-cell">{{ formattedContractData.customerIdNumber }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell" rowspan="3">법정대리인<br>또는 가족</td>
                                        <td class="label-cell">성명</td>
                                        <td class="value-cell"></td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">생년월일</td>
                                        <td class="value-cell"></td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">가입자·피부양자와의 관계</td>
                                        <td class="value-cell">{{ formattedContractData.guardTarget }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell" rowspan>전화번호<br>(위임사항 및<br>지급내역 수신용)</td>
                                        <td class="value-cell" colspan="2">
                                            {{ formattedContractData.customerContact }}
                                            <span class="checkbox-text">[ ] 문자메시지 수신동의</span>
                                            <br>
                                            <div class="instruction-note">
                                                ※ 위임처리결과 및 지급내역 등을 전송받을 연락처로 정확히 적어 주시기 바랍니다. (문자메시지 수신을 동의한 경우에만 발송)
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ② 준요양기관 섹션 -->
                                    <tr>
                                        <td class="section-title-cell" rowspan="4">② 준요양기관</td>
                                        <td class="label-cell">상호</td>
                                        <td class="value-cell" colspan="2">{{ formattedContractData.companyName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">사업자등록번호<br>(법인등록번호)</td>
                                        <td class="value-cell" colspan="2">{{
                                            formattedContractData.companyBnum }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">대표자</td>
                                        <td class="value-cell" colspan="2">{{
                                            formattedContractData.companyCeoName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">전화번호<br>(휴대전화번호)</td>
                                        <td class="value-cell" colspan="2">{{ formattedContractData.companyContact }}
                                        </td>
                                    </tr>

                                    <!-- ③ 요양비 수령계좌 섹션 -->
                                    <tr>
                                        <td class="section-title-cell" rowspan="4">③ 요양비<br>수령계좌</td>
                                        <td class="label-cell">수령자</td>
                                        <td class="value-cell" colspan="2">{{ formattedContractData.companyName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell" rowspan="3">수령계좌</td>
                                        <td class="label-cell">금융기관명</td>
                                        <td class="value-cell">{{ formattedContractData.bank_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">예금주</td>
                                        <td class="value-cell">{{ formattedContractData.bank_username }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-cell">계좌번호</td>
                                        <td class="value-cell">{{ formattedContractData.bank_number }}</td>
                                    </tr>

                                    <!-- ④ 위임사항 섹션 -->
                                    <tr>
                                        <td class="section-title-cell">④ 위임사항</td>
                                        <td class="authorization-items-cell" colspan="3">
                                            <div class="authorization-items">
                                                <div class="items-column">
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.peritonealDialysis) ? '✔' : ' ' }}]
                                                                자동복막투석 소모성 재료</span>
                                                        </label>
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.peritonealFluid) ? '✔' : ' ' }}]
                                                                복막관류액</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.homeOxygen) ? '✔' : ' ' }}] 가정용
                                                                산소발생기</span>
                                                        </label>
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.portableOxygen) ? '✔' : ' ' }}] 휴대용
                                                                산소발생기</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.diabetes) ? '✔' : ' ' }}] 당뇨병 소모성
                                                                재료</span>
                                                        </label>
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.glucoseSensor) ? '✔' : ' ' }}]
                                                                연속혈당측정용 전극(센서)</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.selfUrine) ? '✔' : ' ' }}] 자가도뇨 소모성
                                                                재료</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.ventilator) ? '✔' : ' ' }}] 인공호흡기 및
                                                                기본소모품</span>
                                                        </label>
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.ventilatorAccessories) ? '✔' : ' '
                                                            }}] 선택소모품</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.coughInducer) ? '✔' : ' ' }}]
                                                                기침유발기</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems && authorizationItems.cpap) ?
                                                                '✔' : ' ' }}] 양압기 및 소모품</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.continuousGlucose) ? '✔' : ' ' }}]
                                                                연속혈당측정기</span>
                                                        </label>
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.insulinPump) ? '✔' : ' ' }}]
                                                                인슐린자동주입기</span>
                                                        </label>
                                                    </div>
                                                    <div class="item-row">
                                                        <label class="checkbox-item">
                                                            <span>[{{ (authorizationItems &&
                                                                authorizationItems.childbirth) ? '✔' : ' ' }}]
                                                                출산비</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="instruction-note">
                                                ※ [✔]표시, 중복 표시 가능
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- ⑤ 위임기간 섹션 -->
                                    <tr>
                                        <td class="section-title-cell">⑤ 위임기간</td>
                                        <td class="value-cell-2" colspan="3">
                                            {{ formattedAuthorizationPeriod }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- 결론 문구 -->
                        <div class="conclusion-text">
                            「국민건강보험법」 제49조제3항 및 같은 법 시행규칙 제23조제4항에 따라 요양비 지급 청구에 관한 사항을 위와 같이 위임합니다.
                        </div>

                        <!-- 서명 섹션 -->
                        <div class="authorization-signature-section">
                            <div class="authorization-signature-date">{{ formattedContractData.contractDate }}</div>
                            <div class="authorization-signature-info">
                                <span class="authorization-signature-label">위임인</span>
                                <span class="authorization-signature-name">{{ formattedContractData.customerName
                                }}</span>
                                <span class="authorization-signature-placeholder">(서명 또는 인)</span>
                                <div class="authorization-signature-canvas-container">
                                    <canvas ref="signatureCanvas" class="authorization-signature-canvas"
                                        @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
                                        @mouseleave="stopDrawing" @touchstart="startDrawingTouch" @touchmove="drawTouch"
                                        @touchend="stopDrawing"></canvas>
                                    <button @click="clearSignature"
                                        class="clear-authorization-signature-btn">지우기</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>``
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    name: 'ContractModal',

    props: {
        contractData: {
            type: Object,
            default: () => ({
                contractDate: '',
                companyName: '',
                companyAddress: '',
                companyContact: '',
                companykey: '',
                customerName: '',
                customerAddress: '',
                customerContact: '',
                customerIdNumber: '',
                guardName: '',
                guardTarget: '',
                bank_name: '',
                bank_number: '',
                bank_username: '',
                orderId: ''
            })
        },
        products: {
            type: Array,
            default: () => []
        }
    },

    emits: ['register-pdf', 'register-all-pdf', 'close', 'update-contract-date'],

    data() {
        return {
            isGeneratingPDF: false,
            currentPage: 1,
            maxVisiblePages: 5,
            // 서명 관련 데이터
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            signatureData: null,
            // 문서 타입 관리
            documentType: 'contract', // 기본값
            documentTypes: {
                contract: {
                    name: '산소치료서비스 표준계약서',
                    pages: 4,
                    fileName: '산소치료서비스_표준계약서'
                },
                authorization: {
                    name: '요양비지급청구위임장',
                    pages: 1,
                    fileName: '요양비지급청구위임장'
                }
            },
            // 서명 상태 추가
            signatureStatus: {
                contract: false,
                authorization: false,
                details: []
            },
            // 계약일 편집 관련
            isEditingContractDate: false,
            editableContractDate: null
        }
    },

    mounted() {
        this.initSignatureCanvas();
        // 편집 가능한 계약일 초기화
        this.initializeEditableContractDate();
        // 컴포넌트 마운트 시 서명 상태 조회 및 복원
        this.$nextTick(() => {
            setTimeout(() => {
                this.restoreSignatureBasedOnStatus();
                this.updateSignatureStatusDisplay();
            }, 100);
        });
    },

    watch: {
        // contractData 변경 시 편집 가능한 계약일 업데이트
        'contractData.contractDate'(newDate) {
            if (newDate && !this.isEditingContractDate) {
                this.initializeEditableContractDate();
            }
        },

        currentPage(newPage) {
            // 페이지 변경 시 서명 상태에 따른 복원
            if ((newPage === 4 && this.documentType === 'contract') ||
                (newPage === 1 && this.documentType === 'authorization')) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.restoreSignatureBasedOnStatus();
                    }, 100);
                });
            }
        },

        // 문서 타입 변경 시 서명 상태에 따른 복원
        documentType(newType) {
            this.currentPage = 1; // 첫 페이지로 이동
            this.$nextTick(() => {
                setTimeout(() => {
                    this.restoreSignatureBasedOnStatus();
                    this.updateSignatureStatusDisplay();
                }, 100);
            });
        },
    },

    computed: {
        // 위임사항 체크 상태 계산
        authorizationItems() {
            const items = {
                // 산소발생기 관련
                homeOxygen: false,
                portableOxygen: false,

                // 당뇨 관련
                diabetes: false,

                // 기타 항목들
                peritonealDialysis: false,
                peritonealFluid: false,
                selfUrine: false,
                ventilator: false,
                ventilatorAccessories: false,
                coughInducer: false,
                cpap: false,
                continuousGlucose: false,
                insulinPump: false,
                childbirth: false
            };

            // products 배열이 없거나 비어있으면 기본값 반환
            if (!this.products || !Array.isArray(this.products) || this.products.length === 0) {
                return items;
            }

            // products 배열을 순회하며 품목 확인
            this.products.forEach(product => {
                const name1 = (product.name1 || '').toLowerCase();
                const name2 = (product.name2 || '').toLowerCase();
                const name3 = (product.name3 || '').toLowerCase();

                // 산소발생기 확인
                if (name1.includes('산소') || name1.includes('oxygen') ||
                    name2.includes('산소') || name2.includes('oxygen') ||
                    name3.includes('산소') || name3.includes('oxygen')) {

                    // 가정용 산소발생기
                    if (name2.includes('가정용') || name2.includes('home')) {
                        items.homeOxygen = true;
                    }
                    // 휴대용 산소발생기
                    else if (name2.includes('휴대용') || name2.includes('portable')) {
                        items.portableOxygen = true;
                    }
                    // 기본적으로 가정용으로 판단 (휴대용이 명시되지 않은 경우)
                    else {
                        items.homeOxygen = true;
                    }
                }

                // 당뇨 관련 확인
                if (name.includes('당뇨') || name.includes('용품') ||
                    name1.includes('당뇨') || name1.includes('diabetes') ||
                    name2.includes('당뇨') || name2.includes('diabetes')) {
                    items.diabetes = true;
                }
            });

            return items;
        },

        visiblePages() {
            const total = this.totalPages
            const current = this.currentPage
            const max = this.maxVisiblePages
            if (total <= max) return Array.from({ length: total }, (_, i) => i + 1)
            const halfMax = Math.floor(max / 2)
            let start = Math.max(1, current - halfMax)
            let end = Math.min(total, start + max - 1)
            if (end - start + 1 < max) start = Math.max(1, end - max + 1)
            return Array.from({ length: end - start + 1 }, (_, i) => start + i)
        },

        companyStampUrl() {
            const companykey = this.contractData.companykey || '';
            if (!companykey) return '';

            const baseUrl = `${this.$apiUrls.s3Bucket}/Company-image/${companykey}/stamp`;

            const extensions = ['png', 'jpg', 'jpeg'];

            return `${baseUrl}.${extensions[0]}`;
        },

        formattedProducts() {
            return this.products.map(product => ({
                isHomeUse: this.isHomeUseProduct(product),
                modelName: product.name3,
                managementNumber: product.barcodes[0],
                serviceAmount: this.getServiceAmount(product),
                contractPeriod: this.getContractPeriod(product),
                paymentDate: '1'
            }));
        },

        formattedContractDate() {
            // 편집 가능한 계약일이 있으면 그것을 사용, 없으면 원본 사용
            const dateToFormat = this.editableContractDate || this.contractData.contractDate;
            return this.formatContractDate(dateToFormat);
        },

        formattedContractData() {
            return {
                ...this.contractData,
                contractDate: this.formattedContractDate,
                companyContact: this.formatPhoneNumber(this.contractData.companyContact),
                customerContact: this.formatPhoneNumber(this.contractData.customerContact),
                companyBnum: this.formatBusinessNumber(this.contractData.companyBnum),
                bank_number: this.formatBankAccountNumber(this.contractData.bank_number),
                customerIdNumber: this.formatIdNumber(this.contractData.customerIdNumber),
            };
        },

        documentTitle() {
            return this.documentTypes[this.documentType].name;
        },

        totalPages() {
            return this.documentTypes[this.documentType].pages;
        },

        // 위임기간 계산 (오늘부터 5년 뒤 하루 적게)
        formattedAuthorizationPeriod() {
            const today = new Date();
            const endDate = new Date(today);
            endDate.setFullYear(today.getFullYear() + 5);
            endDate.setDate(today.getDate() - 1); // 5년 뒤 하루 적게

            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}년 ${month}월 ${day}일`;
            };

            return `${formatDate(today)}부터 ${formatDate(endDate)}까지 (최장 5년)`;
        }
    },

    methods: {
        // 편집 가능한 계약일 초기화
        initializeEditableContractDate() {
            if (this.contractData.contractDate) {
                const date = new Date(this.contractData.contractDate);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                this.editableContractDate = `${year}-${month}-${day}`;
            } else {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                this.editableContractDate = `${year}-${month}-${day}`;
            }
        },

        // 계약일 편집 시작
        startEditingContractDate() {
            this.isEditingContractDate = true;
            this.$nextTick(() => {
                if (this.$refs.contractDateInput) {
                    this.$refs.contractDateInput.focus();
                    this.$refs.contractDateInput.select();
                }
            });
        },

        // 계약일 편집 완료
        finishEditingContractDate() {
            this.isEditingContractDate = false;
            if (this.editableContractDate) {
                this.updateContractDate();
            }
        },

        // 계약일 편집 취소
        cancelEditingContractDate() {
            this.isEditingContractDate = false;
            // 원래 값으로 복원
            this.initializeEditableContractDate();
        },

        // 계약일 업데이트
        updateContractDate() {
            if (this.editableContractDate) {
                // 부모 컴포넌트에 계약일 변경 알림
                this.$emit('update-contract-date', this.editableContractDate);
            }
        },

        // PDF 파일 등록 메서드 수정
        async registerPDF() {
            try {
                this.isGeneratingPDF = true;

                // 현재 문서 타입의 서명 상태 확인 및 복원
                await this.restoreSignatureBasedOnStatus();

                // PDF 생성
                const pdfBlob = await this.generatePDFBlob();

                // 파일명 생성: contract 타입일 때는 name 필드 사용, 나머지는 fileName 사용
                const fileName = this.documentType === 'contract'
                    ? `${this.contractData.customerName}님 ${this.documentTypes[this.documentType].name}.pdf`
                    : `${this.contractData.customerName}님 ${this.documentTypes[this.documentType].fileName}.pdf`;

                // Blob을 File 객체로 변환
                const pdfFile = new File([pdfBlob], fileName, {
                    type: 'application/pdf'
                });

                // 부모 컴포넌트에 PDF 파일 전달
                this.$emit('register-pdf', {
                    file: pdfFile,
                    fileName: fileName,
                    orderId: this.contractData.orderId,
                    documentType: this.documentType
                });

            } catch (error) {
                console.error('PDF 등록 실패:', error);
                throw error; // 부모 컴포넌트에서 처리하도록 에러 전달
            } finally {
                this.isGeneratingPDF = false;
            }
        },

        // 전체 PDF 파일 등록 메서드 수정
        async registerAllPDF() {
            try {
                this.isGeneratingPDF = true;

                // 모든 문서 타입에 대해 PDF 생성
                const allPdfs = [];

                for (const [type, config] of Object.entries(this.documentTypes)) {
                    try {
                        // 현재 문서 타입을 임시로 변경
                        const originalType = this.documentType;
                        this.documentType = type;
                        this.currentPage = 1; // 첫 페이지로 이동

                        // 해당 문서 타입의 서명 상태 확인 및 복원
                        await this.restoreSignatureBasedOnStatus();

                        // PDF 생성
                        const pdfBlob = await this.generatePDFBlob();

                        // 파일명 생성: contract 타입일 때는 name 필드 사용, 나머지는 fileName 사용
                        const fileName = type === 'contract'
                            ? `${this.contractData.customerName}님 ${config.name}.pdf`
                            : `${this.contractData.customerName}님 ${config.fileName}.pdf`;

                        // Blob을 File 객체로 변환
                        const pdfFile = new File([pdfBlob], fileName, {
                            type: 'application/pdf'
                        });

                        // PDF 정보 저장
                        allPdfs.push({
                            file: pdfFile,
                            fileName: fileName,
                            orderId: this.contractData.orderId,
                            documentType: type
                        });

                        // 원래 문서 타입으로 복원
                        this.documentType = originalType;

                    } catch (error) {
                        console.error(`${type} PDF 생성 실패:`, error);
                        // 개별 PDF 생성 실패해도 계속 진행
                    }
                }

                if (allPdfs.length === 0) {
                    throw new Error('생성된 PDF 파일이 없습니다.');
                }

                // 부모 컴포넌트에 모든 PDF 파일 전달
                this.$emit('register-all-pdf', {
                    pdfs: allPdfs,
                    orderId: this.contractData.orderId,
                    totalCount: allPdfs.length
                });

            } catch (error) {
                console.error('전체 PDF 등록 실패:', error);
                throw error; // 부모 컴포넌트에서 처리하도록 에러 전달
            } finally {
                this.isGeneratingPDF = false;
            }
        },

        // generatePdf 메서드도 수정
        async generatePdf({ autoPrint = false, filename = '산소치료서비스_표준계약서.pdf' } = {}) {
            this.isGeneratingPDF = true
            let printRoot
            try {
                // 현재 문서 타입의 서명이 있으면 복원
                if (this.contractData.orderId) {
                    try {
                        const dbSignature = await this.getSignatureFromDB(this.contractData.orderId, this.documentType);
                        if (dbSignature && dbSignature.startsWith('data:image/')) {
                            this.signatureData = dbSignature;
                        }
                    } catch (error) {
                        console.error('서명 복원 실패:', error);
                    }
                }

                // 서명이 있으면 자동으로 DB에 저장
                if (this.signatureData && this.contractData.orderId) {
                    try {
                        await this.saveSignatureToDB(this.contractData.orderId, this.signatureData, this.documentType);
                    } catch (error) {
                        console.error('DB 저장 실패:', error);
                    }
                }

                printRoot = await this.buildPrintDom()

                // 서명 캔버스에서 border와 버튼 제거
                const signatureCanvas = printRoot.querySelector('.signature-canvas, .authorization-signature-canvas');
                if (signatureCanvas) {
                    signatureCanvas.style.border = 'none';
                    signatureCanvas.style.borderRadius = '0';
                }

                // 지우기 버튼 제거
                const clearButton = printRoot.querySelector('.clear-signature-btn, .clear-authorization-signature-btn');
                if (clearButton) {
                    clearButton.style.display = 'none';
                }

                // A4(mm) -> jsPDF
                const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'p' })
                const pageWidthMM = 210
                const pageHeightMM = 297

                const pages = Array.from(printRoot.querySelectorAll('.print-page'))

                for (let i = 0; i < pages.length; i++) {
                    const el = pages[i]

                    // 서명이 있는 경우 서명 이미지를 추가
                    if (this.signatureData && this.documentType === 'contract' && i === 3) {
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 요양비 문서의 경우 서명 이미지 추가
                    if (this.signatureData && this.documentType === 'authorization' && i === 0) {
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.authorization-signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 고해상도 렌더링
                    const canvas = await html2canvas(el, {
                        scale: 2,
                        backgroundColor: '#ffffff',
                        useCORS: true,
                        logging: false,
                    })
                    const img = canvas.toDataURL('image/jpeg', 0.98)
                    if (i > 0) pdf.addPage()
                    pdf.addImage(img, 'JPEG', 0, 0, pageWidthMM, pageHeightMM, undefined, 'FAST')
                }

                // 파일명을 문서 타입에 따라 설정
                const finalFilename = this.documentType === 'authorization'
                    ? `${this.contractData.customerName}님_요양비지급청구위임장.pdf`
                    : filename;

                if (autoPrint) {
                    pdf.autoPrint()
                    const url = pdf.output('bloburl')
                    const win = window.open(url)
                    if (!win) {
                        Swal.fire({
                            title: '알림',
                            text: '팝업 차단을 해제해주세요.',
                            icon: 'warning',
                            confirmButtonText: '확인'
                        });
                    }
                } else {
                    pdf.save(finalFilename)
                }
            } catch (e) {
                console.error(e)
                throw e; // 부모 컴포넌트에서 처리하도록 에러 전달
            } finally {
                this.cleanupPrintDom(printRoot)
                this.isGeneratingPDF = false
            }
        },

        async generatePdf({ autoPrint = false, filename = '산소치료서비스_표준계약서.pdf' } = {}) {
            this.isGeneratingPDF = true
            let printRoot
            try {
                // 현재 문서 타입의 서명이 있으면 복원
                if (this.contractData.orderId) {
                    try {
                        const dbSignature = await this.getSignatureFromDB(this.contractData.orderId, this.documentType);
                        if (dbSignature && dbSignature.startsWith('data:image/')) {
                            this.signatureData = dbSignature;
                        }
                    } catch (error) {
                        console.error('서명 복원 실패:', error);
                    }
                }

                // 서명이 있으면 자동으로 DB에 저장
                if (this.signatureData && this.contractData.orderId) {
                    try {
                        await this.saveSignatureToDB(this.contractData.orderId, this.signatureData, this.documentType);
                    } catch (error) {
                        console.error('DB 저장 실패:', error);
                    }
                }

                printRoot = await this.buildPrintDom()

                // 서명 캔버스에서 border와 버튼 제거
                const signatureCanvas = printRoot.querySelector('.signature-canvas, .authorization-signature-canvas');
                if (signatureCanvas) {
                    signatureCanvas.style.border = 'none';
                    signatureCanvas.style.borderRadius = '0';
                }

                // 지우기 버튼 제거
                const clearButton = printRoot.querySelector('.clear-signature-btn, .clear-authorization-signature-btn');
                if (clearButton) {
                    clearButton.style.display = 'none';
                }

                // A4(mm) -> jsPDF
                const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'p' })
                const pageWidthMM = 210
                const pageHeightMM = 297

                const pages = Array.from(printRoot.querySelectorAll('.print-page'))

                for (let i = 0; i < pages.length; i++) {
                    const el = pages[i]

                    // 서명이 있는 경우 서명 이미지를 추가
                    if (this.signatureData && this.documentType === 'contract' && i === 3) {
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 요양비 문서의 경우 서명 이미지 추가
                    if (this.signatureData && this.documentType === 'authorization' && i === 0) {
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.authorization-signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 고해상도 렌더링
                    const canvas = await html2canvas(el, {
                        scale: 2,
                        backgroundColor: '#ffffff',
                        useCORS: true,
                        logging: false,
                    })
                    const img = canvas.toDataURL('image/jpeg', 0.98)
                    if (i > 0) pdf.addPage()
                    pdf.addImage(img, 'JPEG', 0, 0, pageWidthMM, pageHeightMM, undefined, 'FAST')
                }

                // 파일명을 문서 타입에 따라 설정
                const finalFilename = this.documentType === 'authorization'
                    ? `${this.contractData.customerName}님_요양비지급청구위임장.pdf`
                    : filename;

                if (autoPrint) {
                    pdf.autoPrint()
                    const url = pdf.output('bloburl')
                    const win = window.open(url)
                    if (!win) {
                        try {
                            await Swal.fire({
                                title: '알림',
                                text: '팝업 차단을 해제해주세요.',
                                icon: 'warning',
                                confirmButtonText: '확인'
                            });
                        } catch (swalError) {
                            console.warn('SweetAlert2 오류 (무시 가능):', swalError);
                        }
                    }
                } else {
                    pdf.save(finalFilename)
                }
            } catch (e) {
                console.error(e)
                try {
                    await Swal.fire({
                        title: '오류',
                        text: 'PDF 생성 중 오류가 발생했습니다.',
                        icon: 'error',
                        confirmButtonText: '확인'
                    });
                } catch (swalError) {
                    console.warn('SweetAlert2 오류 (무시 가능):', swalError);
                }
            } finally {
                this.cleanupPrintDom(printRoot)
                this.isGeneratingPDF = false
            }
        },

        async generatePDFBlob() {
            let printRoot;
            try {
                // 현재 문서 타입의 서명이 있으면 복원
                if (this.contractData.orderId) {
                    try {
                        const dbSignature = await this.getSignatureFromDB(this.contractData.orderId, this.documentType);
                        if (dbSignature && dbSignature.startsWith('data:image/')) {
                            this.signatureData = dbSignature;
                        }
                    } catch (error) {
                        console.error('서명 복원 실패:', error);
                    }
                }

                // 서명이 있으면 자동으로 DB에 저장
                if (this.signatureData && this.contractData.orderId) {
                    try {
                        await this.saveSignatureToDB(this.contractData.orderId, this.signatureData, this.documentType);
                    } catch (error) {
                        console.error('DB 저장 실패:', error);
                    }
                }

                printRoot = await this.buildPrintDom();

                // 서명 캔버스에서 border와 버튼 제거
                const signatureCanvas = printRoot.querySelector('.signature-canvas, .authorization-signature-canvas');
                if (signatureCanvas) {
                    signatureCanvas.style.border = 'none';
                    signatureCanvas.style.borderRadius = '0';
                }

                // 지우기 버튼 제거
                const clearButton = printRoot.querySelector('.clear-signature-btn, .clear-authorization-signature-btn');
                if (clearButton) {
                    clearButton.style.display = 'none';
                }

                // A4(mm) -> jsPDF
                const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'p' });
                const pageWidthMM = 210;
                const pageHeightMM = 297;

                const pages = Array.from(printRoot.querySelectorAll('.print-page'));

                for (let i = 0; i < pages.length; i++) {
                    const el = pages[i];

                    // 서명이 있는 경우 서명 이미지를 추가
                    if (this.signatureData && this.documentType === 'contract' && i === 3) { // 계약서 4페이지(서명 페이지)인 경우
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 요양비 문서의 경우 서명 이미지 추가
                    if (this.signatureData && this.documentType === 'authorization' && i === 0) { // 요양비 문서 1페이지인 경우
                        const signatureImg = document.createElement('img');
                        signatureImg.src = this.signatureData;
                        signatureImg.style.width = '150px';
                        signatureImg.style.height = '50px';
                        signatureImg.style.position = 'absolute';
                        signatureImg.style.top = '0';
                        signatureImg.style.left = '0';
                        signatureImg.style.zIndex = '10';
                        signatureImg.style.background = 'transparent';

                        const signatureContainer = el.querySelector('.authorization-signature-canvas-container');
                        if (signatureContainer) {
                            signatureContainer.appendChild(signatureImg);
                        }
                    }

                    // 고해상도 렌더링
                    const canvas = await html2canvas(el, {
                        scale: 2,
                        backgroundColor: '#ffffff',
                        useCORS: true,
                        logging: false,
                    });
                    const img = canvas.toDataURL('image/jpeg', 0.98);
                    if (i > 0) pdf.addPage();
                    pdf.addImage(img, 'JPEG', 0, 0, pageWidthMM, pageHeightMM, undefined, 'FAST');
                }

                // PDF를 Blob으로 변환
                const pdfBlob = pdf.output('blob');
                return pdfBlob;

            } catch (error) {
                console.error('PDF Blob 생성 실패:', error);
                throw error;
            } finally {
                this.cleanupPrintDom(printRoot);
            }
        },

        // 문서 타입 변경 메서드 추가
        changeDocumentType(type) {
            if (this.documentTypes[type]) {
                this.documentType = type;
                this.currentPage = 1; // 첫 페이지로 이동
            }
        },

        // 서명 캔버스 초기화
        initSignatureCanvas() {
            this.$nextTick(() => {
                const canvas = this.$refs.signatureCanvas;
                if (canvas) {
                    const ctx = canvas.getContext('2d');

                    // 고정 크기로 설정
                    canvas.width = 80;
                    canvas.height = 60;

                    // 캔버스 스타일 설정 - 매우 굵게
                    ctx.strokeStyle = '#000000';
                    ctx.lineWidth = 4; // 매우 굵게 설정
                    ctx.lineCap = 'round';
                    ctx.lineJoin = 'round';
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, 80, 60);
                }
            });
        },

        // 마우스 이벤트 핸들러
        startDrawing(e) {
            this.isDrawing = true;
            const canvas = this.$refs.signatureCanvas;
            const ctx = canvas.getContext('2d');

            // 그리기 시작할 때도 lineWidth 재설정
            ctx.lineWidth = 4;
            ctx.strokeStyle = '#000000';
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            const rect = canvas.getBoundingClientRect();
            const scaleX = canvas.width / rect.width;
            const scaleY = canvas.height / rect.height;

            this.lastX = (e.clientX - rect.left) * scaleX;
            this.lastY = (e.clientY - rect.top) * scaleY;
        },

        draw(e) {
            if (!this.isDrawing) return;

            const canvas = this.$refs.signatureCanvas;
            const ctx = canvas.getContext('2d');

            // 그리기 중에도 lineWidth 재설정
            ctx.lineWidth = 4;
            ctx.strokeStyle = '#000000';
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            const rect = canvas.getBoundingClientRect();
            const scaleX = canvas.width / rect.width;
            const scaleY = canvas.height / rect.height;

            const currentX = (e.clientX - rect.left) * scaleX;
            const currentY = (e.clientY - rect.top) * scaleY;

            ctx.beginPath();
            ctx.moveTo(this.lastX, this.lastY);
            ctx.lineTo(currentX, currentY);
            ctx.stroke();

            this.lastX = currentX;
            this.lastY = currentY;
        },

        stopDrawing() {
            this.isDrawing = false;
            this.saveSignatureData();
        },

        // 터치 이벤트 핸들러
        startDrawingTouch(e) {
            e.preventDefault();
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent('mousedown', {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            this.startDrawing(mouseEvent);
        },

        drawTouch(e) {
            e.preventDefault();
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent('mousemove', {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            this.draw(mouseEvent);
        },

        // 서명 데이터 저장 (문서 타입별 구분)
        async saveSignatureData() {
            const canvas = this.$refs.signatureCanvas;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;

                let hasContent = false;
                for (let i = 0; i < data.length; i += 4) {
                    const r = data[i];
                    const g = data[i + 1];
                    const b = data[i + 2];
                    const a = data[i + 3];

                    if (a > 0 && (r < 250 || g < 250 || b < 250)) {
                        hasContent = true;
                        break;
                    }
                }

                if (hasContent) {
                    const tempCanvas = document.createElement('canvas');
                    tempCanvas.width = canvas.width;
                    tempCanvas.height = canvas.height;
                    const tempCtx = tempCanvas.getContext('2d');

                    tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);

                    const originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const newImageData = tempCtx.createImageData(tempCanvas.width, tempCanvas.height);

                    for (let i = 0; i < originalImageData.data.length; i += 4) {
                        const r = originalImageData.data[i];
                        const g = originalImageData.data[i + 1];
                        const b = originalImageData.data[i + 2];
                        const a = originalImageData.data[i + 3];

                        if (a > 0 && (r < 250 || g < 250 || b < 250)) {
                            newImageData.data[i] = r;
                            newImageData.data[i + 1] = g;
                            newImageData.data[i + 2] = b;
                            newImageData.data[i + 3] = a;
                        } else {
                            newImageData.data[i] = 0;
                            newImageData.data[i + 1] = 0;
                            newImageData.data[i + 2] = 0;
                            newImageData.data[i + 3] = 0;
                        }
                    }

                    tempCtx.putImageData(newImageData, 0, 0);
                    this.signatureData = tempCanvas.toDataURL('image/png');

                    if (this.contractData.orderId) {
                        try {
                            await this.saveSignatureToDB(this.contractData.orderId, this.signatureData, this.documentType);
                        } catch (error) {
                            console.error('DB 저장 실패:', error);
                        }
                    }

                    // 서명 저장 후 상태 업데이트
                    await this.updateSignatureStatusDisplay();
                } else {
                    this.signatureData = null;
                    if (this.contractData.orderId) {
                        try {
                            await this.deleteSignatureFromDB(this.contractData.orderId, this.documentType);
                        } catch (error) {
                            console.error('DB 삭제 실패:', error);
                        }
                    }

                    // 서명 삭제 후 상태 업데이트
                    await this.updateSignatureStatusDisplay();
                }
            }
        },

        // 서명 상태 조회
        async getSignatureStatus() {
            if (this.contractData.orderId) {
                try {
                    const response = await this.$axios({
                        method: 'get',
                        url: `${this.$apiUrls.hanqmedi}/contract/signature-status/${this.contractData.orderId}`,
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    if (response.data && response.data.success) {
                        return response.data.data;
                    } else {
                        console.warn('서명 상태 조회 실패');
                        return { contract: false, authorization: false, details: [] };
                    }
                } catch (error) {
                    console.error('서명 상태 조회 실패:', error);
                    return { contract: false, authorization: false, details: [] };
                }
            } else {
                console.warn('orderId가 없어서 서명 상태를 조회할 수 없습니다.');
                return { contract: false, authorization: false, details: [] };
            }
        },

        // 서명 상태에 따른 서명 복원
        async restoreSignatureBasedOnStatus() {
            const status = await this.getSignatureStatus();

            if (this.documentType === 'contract' && status.contract) {
                // 계약서 서명이 있는 경우 복원
                await this.restoreSignatureData();
            } else if (this.documentType === 'authorization' && status.authorization) {
                // 위임장 서명이 있는 경우 복원
                await this.restoreSignatureData();
            } else {
                // 서명이 없는 경우 캔버스 초기화
                this.clearSignatureCanvas();
            }
        },

        // 캔버스 초기화 (서명 없을 때)
        clearSignatureCanvas() {
            const canvas = this.$refs.signatureCanvas;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                this.signatureData = null;
            }
        },

        // 서명 상태 표시 (UI에 표시용)
        async updateSignatureStatusDisplay() {
            const status = await this.getSignatureStatus();

            // 서명 상태를 data에 저장하여 UI에서 활용
            this.signatureStatus = status;
        },

        // DB에 서명 저장 (문서 타입별 구분)
        async saveSignatureToDB(orderId, signatureData, documentType = 'contract') {
            try {
                const response = await this.$axios({
                    method: 'post',
                    url: `${this.$apiUrls.hanqmedi}/contract/signature`,
                    data: {
                        orderId: orderId,
                        signatureData: signatureData,
                        type: documentType
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                return response.data;
            } catch (error) {
                console.error('서명 저장 실패:', error);
                throw new Error('서명 저장 실패');
            }
        },

        // DB에서 서명 조회 (문서 타입별 구분)
        async getSignatureFromDB(orderId, documentType = 'contract') {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: `${this.$apiUrls.hanqmedi}/contract/signature/${orderId}`,
                    params: {
                        type: documentType
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data && response.data.success) {
                    return response.data.data;
                } else {
                    console.warn('서명 데이터가 없습니다.');
                    return null;
                }
            } catch (error) {
                console.error('서명 조회 실패:', error);
                return null;
            }
        },

        // DB에서 서명 삭제 (문서 타입별 구분)
        async deleteSignatureFromDB(orderId, documentType = 'contract') {
            try {
                const response = await this.$axios({
                    method: 'delete',
                    url: `${this.$apiUrls.hanqmedi}/contract/signature/${orderId}`,
                    params: {
                        type: documentType
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                return response.data;
            } catch (error) {
                console.error('서명 삭제 실패:', error);
                throw new Error('서명 삭제 실패');
            }
        },

        // 서명 데이터 복원 (문서 타입별 구분)
        async restoreSignatureData() {
            if (this.contractData.orderId) {
                try {
                    const dbSignature = await this.getSignatureFromDB(this.contractData.orderId, this.documentType);

                    if (dbSignature && dbSignature.startsWith('data:image/')) {
                        this.signatureData = dbSignature;
                        this.$nextTick(() => {
                            this.drawSignatureOnCanvas();
                        });
                    } else {
                        console.warn('유효하지 않은 서명 데이터입니다.');
                        this.clearSignatureCanvas();
                    }
                } catch (error) {
                    console.error('DB 조회 실패:', error);
                    this.clearSignatureCanvas();
                }
            } else {
                console.warn('orderId가 없어서 서명을 조회할 수 없습니다.');
                this.clearSignatureCanvas();
            }
        },

        // 서명 지우기 (문서 타입별 구분)
        async clearSignature() {
            const canvas = this.$refs.signatureCanvas;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                this.signatureData = null;

                if (this.contractData.orderId) {
                    try {
                        await this.deleteSignatureFromDB(this.contractData.orderId, this.documentType);
                    } catch (error) {
                        console.error('DB 삭제 실패:', error);
                    }
                }

                // 서명 지운 후 상태 업데이트
                await this.updateSignatureStatusDisplay();
            }
        },

        // 캔버스에 저장된 서명 그리기
        drawSignatureOnCanvas() {
            if (this.signatureData) {
                const canvas = this.$refs.signatureCanvas;
                if (canvas) {
                    const ctx = canvas.getContext('2d');

                    // 캔버스 초기화
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    const img = new Image();
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    };
                    img.onerror = (error) => {
                        console.error('이미지 로드 실패:', error);
                    };
                    img.src = this.signatureData;
                }
            } else {
                console.warn('서명 데이터가 없습니다.');
            }
        },

        // 유틸리티 함수들
        isOxygenProduct(product) {
            const name1 = (product.name1 || '').toLowerCase();
            const name2 = (product.name2 || '').toLowerCase();
            const name3 = (product.name3 || '').toLowerCase();

            return name1.includes('산소') || name1.includes('oxygen') ||
                name2.includes('산소') || name2.includes('oxygen') ||
                name3.includes('산소') || name3.includes('oxygen');
        },

        isHomeOxygenProduct(product) {
            if (!this.isOxygenProduct(product)) return false;

            const name2 = (product.name2 || '').toLowerCase();
            return name2.includes('가정용') || name2.includes('home');
        },

        isPortableOxygenProduct(product) {
            if (!this.isOxygenProduct(product)) return false;

            const name2 = (product.name2 || '').toLowerCase();
            return name2.includes('휴대용') || name2.includes('portable');
        },

        isDiabetesProduct(product) {
            const name1 = (product.name1 || '').toLowerCase();
            const name2 = (product.name2 || '').toLowerCase();
            const name3 = (product.name3 || '').toLowerCase();

            return name1.includes('당뇨') || name1.includes('diabetes') ||
                name2.includes('당뇨') || name2.includes('diabetes') ||
                name3.includes('당뇨') || name3.includes('diabetes');
        },

        formatContractDate(date) {
            if (!date) return '2024년 02월 21일';

            // YYYY-MM-DD 형식인 경우 (date input)
            if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
                const [year, month, day] = date.split('-');
                return `${year}년 ${month}월 ${day}일`;
            }

            // Date 객체나 ISO 문자열인 경우
            const d = new Date(date);
            if (isNaN(d.getTime())) return '2024년 02월 21일';

            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}년 ${month}월 ${day}일`;
        },

        isHomeUseProduct(product) {
            const name1 = (product.name1 || '').toLowerCase();
            const name2 = (product.name2 || '').toLowerCase();
            const name3 = (product.name3 || '').toLowerCase();

            if (name2.includes('가정용')) {
                return true;
            } else if (name2.includes('휴대용')) {
                return false;
            }

            if (name1.includes('산소') || name1.includes('oxygen') ||
                name3.includes('산소') || name3.includes('oxygen')) {
                return !name1.includes('휴대') && !name1.includes('portable') &&
                    !name3.includes('휴대') && !name3.includes('portable');
            }

            return false;
        },

        getServiceAmount(product) {
            if (product.pcode && product.pcode !== '') {
                return parseInt(product.supplyprice || product.price3 || 0);
            } else {
                return parseInt(product.rentprice || product.buyprice || 0);
            }
        },

        getContractPeriod(product) {
            const startDate = product.oxygenStart;
            const endDate = product.oxygenEnd;

            if (startDate) {
                const start = new Date(startDate);
                const startStr = `${start.getFullYear()}.${String(start.getMonth() + 1).padStart(2, '0')}.${String(start.getDate()).padStart(2, '0')}`;

                if (endDate) {
                    const end = new Date(endDate);
                    const endStr = `${end.getFullYear()}.${String(end.getMonth() + 1).padStart(2, '0')}.${String(end.getDate()).padStart(2, '0')}`;
                    return `${startStr} ~ ${endStr}`;
                } else {
                    // endDate가 없는 경우 startDate만 표시
                    return startStr;
                }
            }

            return '';
        },

        // 주민번호 포맷팅 함수
        formatIdNumber(idNumber) {
            if (!idNumber) return '';

            // 숫자만 추출
            const numbers = idNumber.replace(/\D/g, '');

            // 주민번호는 13자리 (앞 6자리-뒤 7자리)
            if (numbers.length === 13) {
                return `${numbers.slice(0, 6)}-${numbers.slice(6)}`;
            }

            // 외국인등록번호는 13자리 (앞 6자리-뒤 7자리)
            if (numbers.length === 12) {
                return `${numbers.slice(0, 6)}-${numbers.slice(6)}`;
            }

            return idNumber; // 포맷팅할 수 없는 경우 원본 반환
        },

        // 은행 계좌번호 포맷팅 함수
        formatBankAccountNumber(accountNumber) {
            if (!accountNumber) return '';

            // 숫자만 추출
            const numbers = accountNumber.replace(/\D/g, '');

            // 농협은행 특별 처리 (xxx-xxxx-xxxx-xx 형식)
            if (this.contractData.bank_name &&
                (this.contractData.bank_name.includes('농협') ||
                    this.contractData.bank_name.includes('NH') ||
                    this.contractData.bank_name.includes('농업협동조합'))) {

                if (numbers.length >= 10) {
                    if (numbers.length === 10) {
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    } else if (numbers.length === 11) {
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    } else if (numbers.length === 12) {
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    } else if (numbers.length === 13) {
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    } else if (numbers.length === 14) {
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    } else {
                        // 15자리 이상인 경우
                        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}-${numbers.slice(11)}`;
                    }
                }
            }

            // 다른 은행의 일반적인 계좌번호 형식
            if (numbers.length >= 10) {
                if (numbers.length === 10) {
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}`;
                } else if (numbers.length === 11) {
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}`;
                } else if (numbers.length === 12) {
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
                } else if (numbers.length === 13) {
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
                } else if (numbers.length === 14) {
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
                } else {
                    // 15자리 이상인 경우
                    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
                }
            }

            return accountNumber; // 포맷팅할 수 없는 경우 원본 반환
        },

        formatBusinessNumber(businessNumber) {
            if (!businessNumber) return '';

            if (typeof businessNumber === 'number') {
                businessNumber = businessNumber.toString();
            }

            if (typeof businessNumber !== 'string') {
                return '';
            }

            const numbers = businessNumber.replace(/\D/g, '');

            if (numbers.length === 10) {
                return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5)}`;
            }

            return businessNumber;
        },

        formatPhoneNumber(phone) {
            if (!phone) return '';
            const numbers = phone.replace(/\D/g, '');

            if (numbers.length === 11) {
                return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
            } else if (numbers.length === 10) {
                return `${numbers.slice(0, 2)}-${numbers.slice(2, 6)}-${numbers.slice(6)}`;
            } else if (numbers.length === 9) {
                return `${numbers.slice(0, 2)}-${numbers.slice(2, 5)}-${numbers.slice(5)}`;
            }

            return phone;
        },

        // 이벤트 핸들러들
        goToPage(p) {
            if (p >= 1 && p <= this.totalPages) this.currentPage = p;
        },

        goToPreviousPage() {
            if (this.currentPage > 1) this.currentPage--;
        },

        goToNextPage() {
            if (this.currentPage < this.totalPages) this.currentPage++;
        },

        // PDF 관련 함수들
        async waitForAssets(root) {
            // 폰트
            if (document.fonts?.ready) {
                try { await document.fonts.ready } catch { }
            }
            // 이미지
            const imgs = Array.from(root.querySelectorAll('img'))
            await Promise.all(imgs.map(img => {
                if (img.complete) return Promise.resolve()
                return new Promise(res => { img.onload = img.onerror = () => res() })
            }))
            await this.$nextTick()
        },

        async buildPrintDom() {
            // 숨김 프린트 루트 만들기
            const printRoot = document.createElement('div')
            printRoot.className = 'print-root'

            const saved = this.currentPage
            const savedType = this.documentType

            // 문서 타입별로 페이지 수 다르게 처리
            const totalPages = this.documentTypes[this.documentType].pages

            for (let p = 1; p <= totalPages; p++) {
                this.currentPage = p
                await this.$nextTick()

                // 문서 타입별로 다른 요소 선택
                let pageEl;
                if (this.documentType === 'authorization') {
                    // 요양비 문서는 항상 1페이지만 있음
                    pageEl = document.querySelector('.document-wrapper')
                } else {
                    // 계약서는 페이지별로 다른 요소 선택
                    pageEl = document.querySelector('.document-wrapper')
                }

                if (!pageEl) {
                    console.error(`문서 요소를 찾을 수 없습니다. 페이지: ${p}, 타입: ${this.documentType}`);
                    // 빈 페이지 요소 생성
                    const emptyPage = document.createElement('div');
                    emptyPage.className = 'document-wrapper';
                    emptyPage.innerHTML = '<div class="empty-page">문서를 로드할 수 없습니다.</div>';
                    pageEl = emptyPage;
                }

                const clone = pageEl.cloneNode(true)
                clone.classList.add('print-page')
                printRoot.appendChild(clone)

                // 요양비 문서는 1페이지만 처리하고 루프 종료
                if (this.documentType === 'authorization') {
                    break;
                }
            }

            // DOM에 부착
            document.body.appendChild(printRoot)
            // 폰트/이미지 로딩 보장
            await this.waitForAssets(printRoot)

            // 원래 상태 복구
            this.currentPage = saved
            this.documentType = savedType

            return printRoot
        },

        cleanupPrintDom(root) {
            if (root && root.parentNode) root.parentNode.removeChild(root)
        },

        async printDocument() {
            await this.generatePdf({ autoPrint: true });
        },

        async downloadPDF() {
            await this.generatePdf();
        }
    }
}
</script>

<style scoped>
/* ========================================================== */
/* 공통 스타일 */
/* ========================================================== */

/* 문서 타입 선택 드롭다운 */
.document-type-select {
    padding: 6px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: white;
    color: #374151;
    font-size: 14px;
    margin-right: 8px;
    cursor: pointer;
}

.document-type-select:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
}

/* 헤더 */
.modal-header {
    background: #0f4c5c;
    color: white;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.header-buttons {
    display: flex;
    gap: 8px;
}

.btn {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

.btn-print,
.btn-download,
.btn-register {
    background: #ECF8CA;
    border: 2px solid #ECF8CA;
    font-weight: 600;
}

.btn-print:hover:not(:disabled),
.btn-download:hover:not(:disabled),
.btn-register:hover:not(:disabled) {
    background: #ECF8CA;
    border-color: #ECF8CA;
    transform: translateY(-2px);
}

/* 페이지네이션 컨테이너 */
.pagination-container {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 12px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}

/* 페이지네이션 컨트롤 */
.pagination-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pagination-btn {
    padding: 9px 12px;
    border: 1px solid #d1d5db;
    background: white;
    color: #374151;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 60px;
}

.pagination-btn:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
}

.pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
}

.prev-btn {
    margin-right: 4px;
}

.next-btn {
    margin-left: 4px;
}

/* 페이지 번호들 */
.page-numbers {
    display: flex;
    gap: 4px;
    margin: 0 8px;
}

.page-btn {
    width: 36px;
    height: 36px;
    border: 1px solid #d1d5db;
    background: white;
    color: #374151;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-btn:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
}

.page-btn.active {
    background: #0f4c5c;
    color: white;
    border-color: #0f4c5c;
    font-weight: 600;
}

.page-btn.active:hover {
    background: #0d3d4a;
    transform: none;
}

/* 모달 콘텐츠 */
.modal-content {
    flex: 1;
    overflow-y: auto;
    margin-top: 20px;
    padding: 20px;
    background: white;
}

.document-wrapper {
    max-width: 100%;
    margin: 0 auto;
    line-height: 1.6;
    color: #000;
    background: white;
}

/* ========================================================== */
/* 표준계약서 스타일 */
/* ========================================================== */

/* 문서 헤더 */
.document-header {
    text-align: center;
    margin-bottom: 20px;
}

.mini-note {
    font-size: 12px;
    color: #000;
    margin-bottom: 10px;
    text-align: left;
}

.document-title {
    font-size: 20px;
    font-weight: 700;
    color: #000;
    margin: 0;
    text-align: center;
}

/* 서론 */
.intro-section {
    margin-bottom: 20px;
}

.intro-text {
    font-size: 13px;
    line-height: 1.6;
    text-align: justify;
    color: #000;
    margin: 0;
    word-break: keep-all;
}

/* 조항 컨테이너 */
.articles-container {
    margin-bottom: 20px;
}

.article {
    margin-bottom: 20px;
}

.article-title {
    font-size: 14px;
    font-weight: 700;
    color: #000;
    margin-bottom: 8px;
}

.article-content {
    font-size: 14px;
    color: #000;
    line-height: 1.6;
}

.clause {
    margin-bottom: 8px;
    text-align: justify;
}

.clause:last-child {
    margin-bottom: 0;
}

/* 테이블 */
.table-container {
    margin: 10px 0;
}

.contract-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #000;
}

.contract-table th,
.contract-table td {
    border: 1px solid #000;
    padding: 4px;
    text-align: center;
    vertical-align: middle;
    background: white;
    font-weight: normal;
}

.contract-table th {
    background: white;
    font-weight: 700;
    color: #000;
    font-size: 12px;
}

.filled-row td {
    background: white;
    font-weight: normal;
    color: #000;
}

.table-note {
    font-size: 12px;
    color: #000;
    margin-top: 6px;
    text-align: left;
    font-weight: normal;
}

/* 계약일 섹션 */
.contract-date-section {
    text-align: center;
    margin: 30px 0 20px 0;
}

.contract-date {
    font-size: 14px;
    color: #000;
    margin-top: 50px;
    margin-bottom: 50px;
}

.contract-date.clickable {
    cursor: pointer;
    user-select: none;
    transition: color 0.2s;
}

.contract-date.clickable:hover {
    color: #0f4c5c;
    text-decoration: underline;
}

.contract-date-input {
    font-size: 14px;
    color: #000;
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 4px 8px;
    background: white;
    width: auto;
    min-width: 200px;
}

.contract-date-input:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
}

.contract-date {
    font-size: 14px;
    color: #000;
    margin-top: 50px;
    margin-bottom: 50px;
}

/* 서명 섹션 */
.signature-section {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
}

.signature-box {
    text-align: left;
}

.signature-gap {
    margin-bottom: 20px;
}

.signature-party {
    font-size: 14px;
    color: #000;
    margin-bottom: 8px;
    font-weight: normal;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
}

.signature-address {
    font-size: 14px;
    color: #000;
    margin-bottom: 8px;
}

.signature-contact {
    font-size: 14px;
    color: #000;
    margin-bottom: 15px;
}

.signature-name {
    font-size: 14px;
    color: #000;
    margin-left: 30px;
    display: inline-block;
    position: relative;
}

.company-stamp {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -30px;
    left: 85%;
    transform: translateX(-50%);
    object-fit: contain;
}

/* 표준계약서 서명 캔버스 컨테이너 */
.signature-canvas-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -50px 0 10px 70px;
    gap: 10px;
    position: relative;
    z-index: 1;
    width: 100%;
}

.signature-canvas {
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: crosshair;
    background: white;
    width: 150px;
    height: 50px;
    display: block;
    touch-action: none;
}

.clear-signature-btn {
    padding: 6px 8px;
    font-size: 12px;
    background: #f44336;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
}

.clear-signature-btn:hover {
    background: #d32f2f;
}

/* ========================================================== */
/* 요양비지급청구위임장 스타일 */
/* ========================================================== */

.form-header {
    text-align: center;
    position: relative;
}

.form-number {
    font-size: 12px;
    color: #000;
    margin-bottom: 10px;
    text-align: left;
}

.instruction-text {
    font-size: 12px;
    color: #000;
    margin-top: 20px;
    text-align: left;
}

.checkbox-text {
    margin-left: 20px;
    font-size: 12px;
    color: #000;
}

/* 요양비청구위임장 테이블 통일 스타일 */
.unified-form-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    table-layout: fixed;
}

.unified-form-table td {
    border: 1px solid #000;
    padding: 8px;
    vertical-align: top;
}

/* 모든 섹션의 컬럼 너비 통일 */
.unified-form-table .section-title-cell {
    font-weight: 700;
    font-size: 14px;
    width: 80px !important;
    text-align: left;
    vertical-align: middle;
}

.unified-form-table .label-cell {
    font-weight: 700;
    width: 150px !important;
    text-align: center;
    vertical-align: middle;
}

.unified-form-table .value-cell {
    text-align: left;
    vertical-align: middle;
    width: 200px !important;
    font-size: 14px;
}

.unified-form-table .value-cell-2 {
    text-align: center;
    vertical-align: middle;
    width: 200px !important;
    font-size: 14px;
}

.unified-form-table .authorization-items-cell {
    text-align: left;
    width: calc(100% - 270px) !important;
}

.authorization-items-cell {
    text-align: left;
    width: 300px;
}

.authorization-items {
    padding: 5px;
}

.items-column {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.checkbox-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    flex: 1;
}

.checkbox-item:only-child {
    justify-content: flex-start;
}

.instruction-note {
    font-size: 13px;
    color: #666;
    margin-top: 10px;
    text-align: left;
}

.conclusion-text {
    font-size: 14px;
    color: #000;
    margin: 20px 0;
    text-align: center;
    line-height: 1.5;
}

/* 요양비 지급청구 위임장 서명 섹션 */
.authorization-signature-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    align-items: center;
    margin-top: 30px;
}

.authorization-signature-date {
    font-size: 14px;
    color: #000;
    margin-bottom: 5px;
    text-align: center;
}

.authorization-signature-info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #000;
    justify-content: center;
    margin-bottom: 10px;
    margin-left: 100px;
}

.authorization-signature-label {
    font-weight: normal;
}

.authorization-signature-name {
    font-weight: normal;
}

.authorization-signature-placeholder {
    font-weight: normal;
}

/* 요양비 지급청구 위임장 서명 캔버스 컨테이너 */
.authorization-signature-canvas-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    right: 90px;
    z-index: 1;
}

/* 요양비 지급청구 위임장 서명 캔버스 */
.authorization-signature-canvas {
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: crosshair;
    background: white;
    width: 150px;
    height: 50px;
    display: block;
    touch-action: none;
}

/* 요양비 지급청구 위임장 지우기 버튼 */
.clear-authorization-signature-btn {
    padding: 6px 8px;
    font-size: 12px;
    background: #f44336;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.clear-authorization-signature-btn:hover {
    background: #d32f2f;
}

/* ========================================================== */
/* PDF용 스타일 */
/* ========================================================== */

.print-root {
    position: fixed;
    left: -99999px;
    top: 0;
    width: 794px;
    background: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.print-page {
    width: 794px;
    min-height: 1123px;
    box-sizing: border-box;
    padding: 20mm 20mm 20mm 20mm;
    background: #fff;
    box-shadow: none;
    border: 0;
    line-height: 1.6;
    letter-spacing: 0;
    font-size: 16px;
    color: #000;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}

/* ========================================================== */
/* 표준계약서 PDF용 스타일 */
/* ========================================================== */

.print-page .document-title {
    font-size: 24px;
    font-weight: 700;
    margin: 15px 0;
    text-align: center;
    color: #000;
}

.print-page .article-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
    color: #000;
}

.print-page .article-content {
    font-size: 16px;
    line-height: 1.8;
    color: #000;
    margin-bottom: 20px;
}

.print-page .intro-text {
    font-size: 16px;
    line-height: 1.8;
    text-align: justify;
    color: #000;
    margin: 0;
    word-break: keep-all;
}

.print-page .contract-table {
    font-size: 14px;
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
}

.print-page .contract-table th,
.print-page .contract-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
    background: white;
    font-weight: normal;
    font-size: 14px;
}

.print-page .contract-table th {
    background: white;
    font-weight: 700;
    color: #000;
    font-size: 14px;
}

/* 표준계약서 서명 스타일 - 화면과 동일한 위치 */
.print-page .signature-canvas-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -50px 0 10px 120px;
    gap: 10px;
    position: relative;
    z-index: 1;
    width: 100%;
}

.print-page .signature-party,
.print-page .signature-address,
.print-page .signature-contact,
.print-page .signature-name {
    font-size: 16px;
    color: #000;
    margin-bottom: 8px;
}

.print-page .contract-date {
    font-size: 16px;
    color: #000;
    margin: 30px 0;
    text-align: center;
}

.print-page .mini-note {
    font-size: 14px;
    color: #000;
    margin-bottom: 12px;
    text-align: left;
}

.print-page .table-note {
    font-size: 14px;
    color: #000;
    margin-top: 8px;
    text-align: left;
    font-weight: normal;
}

.print-page .article {
    margin-bottom: 30px;
}

.print-page .articles-container {
    margin-top: 50px;
    margin-bottom: 30px;
}

.print-page .intro-section {
    margin-bottom: 30px;
}

.print-page .document-header {
    margin-bottom: 30px;
}

/* PDF용 테이블 컬럼 너비 설정 */
.print-page .contract-table th:nth-child(1),
.print-page .contract-table td:nth-child(1) {
    width: 12%;
}

.print-page .contract-table th:nth-child(2),
.print-page .contract-table td:nth-child(2) {
    width: 15%;
}

.print-page .contract-table th:nth-child(3),
.print-page .contract-table td:nth-child(3) {
    width: 23%;
}

.print-page .contract-table th:nth-child(4),
.print-page .contract-table td:nth-child(4) {
    width: 10%;
}

.print-page .contract-table th:nth-child(5),
.print-page .contract-table td:nth-child(5) {
    width: 18%;
}

.print-page .contract-table th:nth-child(6),
.print-page .contract-table td:nth-child(6) {
    width: 10%;
}

/* 계약일 섹션 */
.print-page .contract-date-section {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 70px;
}

/* PDF용 도장 크기 조정 */
.print-page .company-stamp {
    width: 70px;
    height: 70px;
    top: -30px;
    right: -60px;
}

/* ========================================================== */
/* 요양비지급청구위임장 PDF용 스타일 */
/* ========================================================== */

.print-page .authorization-form {
    border: none;
    padding: 15px;
    margin: 0 auto;
    width: 100%;
    max-width: 200mm;
    box-sizing: border-box;
    background: white;
    page-break-inside: avoid;
    box-shadow: none;
    outline: none;
}

.print-page .unified-form-table {
    font-size: 12px;
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    max-width: 100%;
}

.print-page .unified-form-table td {
    padding: 5px;
    border: 1px solid #000;
    vertical-align: middle;
    font-size: 12px;
    color: #000;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.print-page .section-title-cell {
    width: 70px;
    font-weight: 700;
    font-size: 12px;
    text-align: left;
    vertical-align: middle;
    color: #000;
}

.print-page .label-cell {
    width: 130px;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    color: #000;
}

.print-page .value-cell {
    width: 180px;
    font-size: 12px;
    text-align: left;
    vertical-align: middle;
    color: #000;
}

.print-page .value-cell-2 {
    width: 180px;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    color: #000;
}

.print-page .authorization-items-cell {
    width: calc(100% - 250px);
    font-size: 12px;
    text-align: left;
    color: #000;
}

.print-page .authorization-items {
    padding: 3px;
}

.print-page .items-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.print-page .item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
}

.print-page .checkbox-item {
    font-size: 12px;
    flex: 1;
    color: #000;
}

.print-page .instruction-note {
    font-size: 11px;
    color: #666;
    margin-top: 8px;
    text-align: left;
}

.print-page .conclusion-text {
    font-size: 12px;
    color: #000;
    margin: 15px 0;
    text-align: center;
    line-height: 1.4;
}

.print-page .form-header {
    text-align: center;
    margin-bottom: 15px;
    position: relative;
}

.print-page .form-number {
    font-size: 11px;
    color: #000;
    margin-bottom: 8px;
    text-align: left;
}

.print-page .instruction-text {
    font-size: 11px;
    color: #000;
    margin: 8px 0;
    text-align: left;
}

.print-page .checkbox-text {
    margin-left: 15px;
    font-size: 11px;
    color: #000;
}

/* 요양비지급청구위임장 서명 섹션 PDF용 스타일 */
.print-page .authorization-signature-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    align-items: center;
    margin-top: 20px;
}

.print-page .authorization-signature-date {
    font-size: 12px;
    color: #000;
    margin-bottom: 3px;
    text-align: center;
}

.print-page .authorization-signature-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #000;
    justify-content: center;
    margin-bottom: 8px;
    margin-left: 80px;
}

.print-page .authorization-signature-label,
.print-page .authorization-signature-name,
.print-page .authorization-signature-placeholder {
    font-weight: normal;
    font-size: 12px;
    color: #000;
}

.print-page .authorization-signature-canvas-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    position: relative;
    right: 70px;
    z-index: 1;
}

.print-page .authorization-signature-canvas {
    border: 1px solid #000;
    background: white;
    width: 120px;
    height: 40px;
    display: block;
    cursor: crosshair;
}

.print-page .clear-authorization-signature-btn {
    display: none !important;
}

/* 화질 개선 및 페이지 중앙 정렬 */
.print-page {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    width: 100%;
    max-width: 200mm;
    margin: 0 auto;
    padding: 15px;
    background: white;
}

.print-page * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

/* 테이블 너비 조정 및 위임인 섹션 정렬 개선 */
.print-page .unified-form-table {
    font-size: 12px;
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    max-width: 100%;
}

.print-page .unified-form-table td {
    padding: 5px;
    border: 1px solid #000;
    vertical-align: middle;
    font-size: 12px;
    color: #000;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

/* 위임인 섹션 특별 처리 */
.print-page .unified-form-table tr:first-child td,
.print-page .unified-form-table tr:nth-child(2) td,
.print-page .unified-form-table tr:nth-child(3) td,
.print-page .unified-form-table tr:nth-child(4) td {
    vertical-align: middle;
    height: 35px;
}

/* 박스 제거 */
.print-page .authorization-form {
    border: none;
    padding: 15px;
    margin: 0 auto;
    width: 100%;
    max-width: 200mm;
    box-sizing: border-box;
    background: white;
    page-break-inside: avoid;
    box-shadow: none;
    outline: none;
}

/* ========================================================== */
/* 반응형 */
/* ========================================================== */
@media (max-width: 768px) {
    .modal-header {
        flex-direction: column;
        gap: 8px;
        padding: 10px 16px;
    }

    .header-buttons {
        width: 100%;
        justify-content: center;
    }

    .pagination-container {
        flex-direction: column;
        gap: 8px;
        padding: 10px 16px;
    }

    .pagination-controls {
        order: 2;
        width: 100%;
        justify-content: center;
    }

    .page-numbers {
        margin: 0 4px;
    }

    .page-btn {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    .pagination-btn {
        padding: 6px 10px;
        font-size: 12px;
        min-width: 50px;
    }

    .signature-party {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .signature-name {
        align-self: flex-end;
    }
}

@media (max-width: 480px) {
    .pagination-container {
        padding: 8px 12px;
    }

    .page-numbers {
        gap: 2px;
    }

    .page-btn {
        width: 28px;
        height: 28px;
        font-size: 11px;
    }

    .pagination-btn {
        padding: 4px 8px;
        font-size: 11px;
        min-width: 45px;
    }
}

/* ========================================================== */
/* 인쇄 전용 스타일 */
/* ========================================================== */
@page {
    size: A4;
    margin: 10mm;
}

@media print {

    html,
    body {
        background: #fff !important;
    }

    .modal-header,
    .pagination-container {
        display: none !important;
    }

    .modal-content {
        padding: 0 !important;
        overflow: visible !important;
    }

    .document-wrapper {
        width: auto !important;
        max-width: initial !important;
        box-shadow: none !important;
        break-inside: avoid;
        page-break-inside: avoid;
        margin: 0 !important;
        padding: 0 !important;
    }

    .article {
        break-inside: avoid;
        page-break-inside: avoid;
    }

    .page-break {
        page-break-before: always;
        break-before: page;
    }
}
</style>